import axios from "axios";

const baseUrl = 'https://admin.gndm.it/api'
export const apiService = {
    getTranslations: async (language: string) => {
        try {
            return await axios.get(`${baseUrl}/translations/json/`, {
                params: {
                    language: language,
                }
            });
        } catch (error) {
            throw error;
        }
    },
    getCollezioni: async () => {
        try {
            return await axios.get(`${baseUrl}/contents/collezione/`);
        } catch (error) {
            throw error;
        }
    },
    getPalazzo: async () => {
        try {
            return await axios.get(`${baseUrl}/contents/palazzo/`);
        } catch (error) {
            throw error;
        }
    },
    getPercorso: async () => {
        try {
            return await axios.get(`${baseUrl}/contents/percorso/`);
        } catch (error) {
            throw error;
        }
    },
    getSinglePercorso: async (id: any) => {
        try {
            return await axios.get(`${baseUrl}/contents/percorso/${id}`);
        } catch (error) {
            throw error;
        }
    },
    getAudioguida: async (id: any) => {
        try {
            return await axios.get(`${baseUrl}/contents/audioguida/${id}`);
        } catch (error) {
            throw error;
        }
    },
};
